import BaseService from './_base.service';

export const minfocusService = {
    page,
    edit,
    search,
    combo,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/lens/attr/minfocus/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/lens/attr/minfocus/page/"+page+"/"+size,filter, callback, true)
}
function combo(callback) {
    return BaseService.get("/lens/attr/minfocus/combo/", callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/lens/attr/minfocus/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/lens/attr/minfocus/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/lens/attr/minfocus/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/lens/attr/minfocus/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/lens/attr/minfocus/"+id+"/logic", callback);
}
